module.exports = __webpack_public_path__ + "static/img/dark.5d68ad77.svg";